import { type ExperienceItem } from "@/components/design-system/ExperienceCard/ExperienceCard";

export const cards: readonly ExperienceItem[] = [
  {
    image: "/emp-employee-1.png",
    title: "Answers, not articles",
    description:
      "Employees ask real questions about budgeting, debt, savings goals, and benefits decisions. Bravo answers them conversationally, personally, and 24/7.",
  },
  {
    image: "/emp-employee-2.png",
    title: "Benefits understood",
    description:
      "Plain-language explanations and proactive surfacing of untapped value — HSA limits, unclaimed 401(k) match, and more.",
  },
  {
    image: "/emp-employee-3.png",
    title: "Responsible guidance",
    description:
      "Compliance guardrails built in. Bravo never gives regulated advice — it guides, informs, and refers, keeping you protected.",
  },
  {
    image: "/emp-employee-4.png",
    title: "Employer intelligence",
    description:
      "Aggregated, anonymised signals on benefit utilisation and financial stress — giving HR the data to act before problems compound.",
  },
];
